import { render, staticRenderFns } from "./eventRemoteUploadImageComponent.vue?vue&type=template&id=234679d0&scoped=true&"
import script from "./eventRemoteUploadImageComponent.vue?vue&type=script&lang=ts&"
export * from "./eventRemoteUploadImageComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234679d0",
  null
  
)

export default component.exports